import { StyleSheet } from 'react-native'

import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  stepTitle: {
    fontSize: Fonts.size.h4,
    marginVertical: 15,
    ...Fonts.type.bold,
  },
  stepDesc: theme => ({
    fontSize: Fonts.size.regular,
    color: theme.colors.textColorTwo,
    fontFamily: Fonts.type.VFFont,
    lineHeight: 18,
  }),
  container: {
    paddingBottom: 20,
    paddingHorizontal: 16,
    //minHeight: 280,
  },
  cardStyle: {
    marginTop: 20,
  },

  idContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    marginLeft: 10,
  },
  title: theme => ({
    color: theme.colors.textColorTwo,
    fontSize: Fonts.size.h5,
    fontFamily: Fonts.type.bold.fontFamily,
    fontWeight: Fonts.type.bold.fontWeight,
  }),
  explanationText: {
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.regularSmall,
    marginTop: 20,
    lineHeight: 18,
  },
  btnStyle: {
    marginTop: 20,
    marginBottom: 0,
  },
  line: theme => ({
    marginTop: 20,
    backgroundColor: theme.colors.borderColorThree,
    zIndex: -1
  }),
  inputContainer: {
    // maxHeight:55,
    marginVertical: 10,
    height: 55,
    marginHorizontal: 0,
    // backgroundColor:'red'
  },
  inputText: theme => ({
    color: theme.colors.textColor,
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.h6,
  }),
  button: {
    marginTop: 20,
    zIndex: -1,
  },
  halfContainer: {
    width: '48%',
    marginHorizontal: 0,
    height: 55,
  },
  inputsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  marginStyle: {
    marginTop: 8
  },
  datesContainer: {
    width: '31%',
    marginHorizontal: 0,
    height: 55,
  },
  errorText: {
    fontFamily: Fonts.type.VFFont,
    fontSize: Fonts.size.regularSmall,
    color: Colors.vfRed,
  },
  headerContainer: {
    zIndex: -1,
    marginVertical: 20
  },
  firstHeader: {
    marginBottom: 20
  },
  modalContainer: theme => ({
    alignItems: 'center',
    paddingVertical: 30,
    paddingHorizontal: 16,
    backgroundColor: theme.colors.cardBackgroundColor
  }),
  optionStyle: noBorder => ({
    height: 60,
    borderBottomColor: Colors.lightGrayTwo,
    borderBottomWidth: noBorder ? 0 : 1,
    justifyContent: 'center',
    marginHorizontal: 16,
  }),
  takeidButton: {
    marginTop: 15
  },
  cameraModal: (theme, insets) => ({
    marginBottom: 0,
    backgroundColor: theme.colors.backgroundColor,
    paddingBottom: insets.bottom
  }),
  // Modal non scrollable content
  modalContentContainerWraper: {
    flexGrow: 1,
    paddingHorizontal: 16,
    paddingVertical: 32,
  },
  modalContentWraper2: {
    flexGrow: 1,
    marginBottom: 32,
    justifyContent: 'center',
    alignItems: 'center',
  },
  cameraModalErrorTitleStyle: {
    marginTop: 35,
    marginBottom: 16,
    ...Fonts.type.bold,
    fontSize: Fonts.size.h4,
    textAlign: 'center'
  },
  cameraModalErrorDescriptionStyle: {
    fontSize: Fonts.size.h6,
    textAlign: 'center',
    lineHeight: 22
  },
  secondaryButton: {
    marginTop: 16,
  },
  dropdownSearchable: {
    marginBottom: -18,
    marginHorizontal: 0,
    position: 'relative'
  },
  dropdownStyle: {
    marginTop: 0,
    position: 'relative',
    maxHeight: 250,
    top: -35
  },
  birthDayLabel: {
    fontSize: Fonts.size.regular,
    fontFamily: Fonts.type.VFFont,
    marginTop: 10,
    marginBottom: -5
  },
  modalSubTitle: theme => ({
    fontSize: Fonts.size.regular,
    color: theme.colors.textColorTwo,
    fontFamily: Fonts.type.VFFont,
    lineHeight: 18,
    textAlign: 'center'
  })
})

export default styles
